<template>
	<div class="row">
		<div class="col-sm-12">
			<div class="row">
				<div class="col-sm-4">
					<label for="name">FTP Username</label>
					<input type="text" id="name" autocomplete="off" name="name" :disabled="loading" v-model="record.username" placeholder="Username" class="form-control"/>
				</div>
				<div class="col-sm-4">
					<label>
						FTP Password
						<i class="fa fa-question-circle text-primary" data-toggle="tooltip" data-placement="top" title="Minimum 8 characters in length. Contains the following items: uppercase letters, lowercase letters, numbers, symbols"></i>
					</label>
					<password id="password" name="password" :showCopy="false" :secureLength="8" :disabled="loading" autocomplete="off" v-model="record.password" defaultClass="form-control" :showPassword="true"  :required="true" :badge="false" placeholder="Password"/>
				</div>
				<div class="col-sm-4">
					<button type="submit" @click="store" :disabled="loading" class="btn btn-outline-primary btn-round btn-sm pull-right mt-4">
						<div class="loader small_loader" v-if="loading && action === 'create'"></div>
						<span v-else>
							<i class="fa fa-plus"></i> Create FTP Account
						</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from "sweetalert2";
	import _ from "lodash";
	import uuidv1 from "uuid/v1";
	import zxcvbn from "zxcvbn";
	import Password from "./PasswordStrengthMeter";

	import refreshToken from "../../../../../mixins/refreshTokenMixin";
	import tooltips from "../../../../../mixins/tooltips";

	function initialState() {
		return {
			errors: [],
			action: null,
			record: {
				username: null,
				password: null
			}
		}
	}

	export default {
		name: "FtpCreate",
		props: {
			account: {
				type: Object,
				required: true
			},
			records: {
				type: Array,
				required: true
			},
			loading: {
				required: true
			},
			savesStatus: {
				required: true
			},
		},
		mixins: [refreshToken, tooltips],
		data: function () {
			return initialState();
		},
		components: {
			Password
		},
		watch: {
			loading: function (value) {
				if (value == false) {
					Object.assign(this.$data, initialState());
				}
			},
			savesStatus: function(value){
				if (value) {
					this.cancel();
					this.$emit('update:loading', false);
				}
			}
		},
		methods: {
			store() {
				if (this.loading) {
					return false;
				}
				this.errors = [];
				if (!this.record.username) {
					this.errors.push('Please fill username');
				}

				if (!this.record.password) {
					this.errors.push('Please fill password');
				}

				if (/\s/.test(this.record.password) || /\s/.test(this.record.username)) {
					this.errors.push('Please do not use spaces in your password or username');
				}

				let checkPasswordStrength = zxcvbn(this.record.password);
				if (checkPasswordStrength.score < 4) {
					this.errors.push(checkPasswordStrength.feedback.warning || "You need to enter a stronger password.");
				}

				if (this.errors.length) {
					swal({
						title: "Error message!",
						html: this.errors.join('<br/>'),
						type: "error"
					});
					return false;
				}

				this.action = 'create';

				this.$emit('update:loading', true);
				this.$http.post("ftp/create", {
					grant_type: "token",
					token: this.userToken,
					domain: this.account.domain,
					ip: this.account.ftp.host,
					username: this.record.username,
					password: this.record.password
				})
					.then(() => {
						this.$emit('update-list', _.concat(this.records, {
							id: uuidv1(),
							username: this.record.username,
							password: this.record.password,
							primary: false
						}), "You successfully create FTP account");
						this.cancel();
					})
					.catch((err) => {
						let responseMessage = err.response.data.message;
						if (err.response.status === 422) {
							responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
						}else if(err.response.status === 401){
							responseMessage = "You need update token. Please Try Again!";
							this.refreshToken();
						}
						swal({
							title: "Something went wrong!",
							html: responseMessage,
							type: "error",
							confirmButtonText: "Try Again!",
							confirmButtonColor: "#EE8057"
						});
						this.addLog({
							name: this.user.firstName + " " + this.user.lastName,
							message: `Error create FTP account. Message: ${responseMessage} Code: ${err.response.status}`,
							level: "danger"
						});
					})
					.finally(()=>{
						this.$emit('update:loading', false);
					});

			},
			cancel(){
				Object.assign(this.$data, initialState());
			}
		}
	}
</script>